import React, { Component } from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBars } from '../Outils/MessageBars';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataReservation } from '../../data/DataReservation';
import { EUITextField } from '../EUI/EUITextField';
import { MaxLengths } from '../../data/MaxLenghts';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    peutModifierBlocConditionsParticulieres

    onAffichePanelCommentaire : bool
    onAffichageSansPanel: bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    onChangeValeurMultiple : méthode appelée si onAffichageSansPanel = true (permet de définir plusieurs valeurs à mettre à jour en même temps)
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    reservation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    //peutModifierBlocConditionsParticulieres: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    onActiveBoutonEnregistrer: false,
};

export class FicheCommentaire extends Component {
    _creationContent() {
        // preuve d'une réservation renseignée : https://jsbin.com/ceyexibuxa/edit?html,js,console,output
        const enModeCreation = !this.props.idReservation && this.props.idReservation <= 0;
        const champsActifs = enModeCreation ? true : this.props.peutModifierBlocConditionsParticulieres;

        return <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row" name="divComments">
                <div className="ms-Grid-col ms-sm12 ms-xl8">
                    <div className="ms-Grid-col ms-sm12" name="divConditionsParticulieres">
                        <EUITextField
                            disabled={!champsActifs}
                            label="Conditions particulières de vente"
                            maxLength={MaxLengths.reservation.conditionsParticulieres}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("reservation", "conditionsParticulieres", newValue)}
                            rows={5}
                            value={this.state.reservation.conditionsParticulieres}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12" name="divCommentaires">
                        <EUITextField
                            disabled={!champsActifs}
                            label="Commentaires"
                            maxLength={MaxLengths.reservation.remarques}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("reservation", "remarques", newValue)}
                            rows={5}
                            value={this.state.reservation.remarques}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 labelClausesSpecifiques_Commentaire">Clauses spécifiques</div>
                    <div className="ms-Grid-col ms-sm12" name="divDemandeBeneficePinel">
                        <Toggle
                            label="Demander le bénéfice de la réduction d'impôt Pinel visée à l'article 199 novovicies du CGI"
                            checked={this.state.reservation.demandeBeneficePinel}
                            onText="Oui"
                            offText="Non"
                            inlineLabel
                            onChange={(e, isChecked) => this._onMiseAJourChampDemandeBeneficePinel(isChecked)}
                            disabled={!champsActifs}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6">Frais et commissions direct et indirect :</div>
                    <div className="ms-Grid-col ms-sm12 ms-lg3" name="divFraisCommissionMontant">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label=""
                            placeholder="0.00"
                            disabled={!this.state.reservation.demandeBeneficePinel}
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'fraisCommissionMontant', false, 2)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reservation', 'fraisCommissionMontant')}
                            onBlur={e => this._onMiseAJourChampNombre("reservation", "fraisCommissionMontant", e.target.value, this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'fraisCommissionMontant', e, false, 2)}
                            deferredValidationTime={0}
                            required={this.state.reservation.demandeBeneficePinel}
                            suffix="€"
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg3"></div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6"></div>
                    <div className="ms-Grid-col ms-sm12 ms-lg3 mt-1" name="divFraisCommissionPourcentage">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label=""
                            placeholder="0.00"
                            disabled={!this.state.reservation.demandeBeneficePinel}
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'fraisCommissionPourcentage', false, 2)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reservation', 'fraisCommissionPourcentage')}
                            onBlur={e => this._onMiseAJourChampNombre("reservation", "fraisCommissionPourcentage", e.target.value, this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'fraisCommissionPourcentage', e, false, 2)}
                            deferredValidationTime={0}
                            required={this.state.reservation.demandeBeneficePinel}
                            suffix="%"
                        />
                    </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl4">
                    <div className="zoneAide">Saisissez tout élément permettant le bon traitement du dossier.</div>
                </div>
            </div>
        </div>;
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du commentaire et des conditions particulières'
        });

        var ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

        ficheReservation_Simple
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    stateTemp.reservation = objetData[0];

                    //stateTemp.peutModifierBlocConditionsParticulieres = this.props.peutModifierBlocConditionsParticulieres;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                    this._onVerificationFormulaire();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    // KP - 23/12/2019 - Validation du formulaire inutile ? A supprimer si oui.
    //_validationFormulaire(item) {
    //    let estValide = true;
    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //    }
    //    else {
    //        estValide = false;
    //    }
    //    return estValide;
    //}

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du commentaire et des conditions particulières en cours'
        });

        var miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onOpen = () => {
        //const idReservationRenseigne = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0]);
        //const idOperationRenseigne = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0]);
        //if (idReservationRenseigne && idOperationRenseigne)
        //    this._chargementDonnees();

        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();

    };

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'CommentaireReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur);

        if (this.props.onAffichageSansPanel) {
            let tabValeurAMettreAJour = new Array();
            for (var i = 0; i < 1; i++)
                tabValeurAMettreAJour[i] = new Array();
            tabValeurAMettreAJour[0][0] = nomPropriete;
            tabValeurAMettreAJour[0][1] = valeur;

            this.props.onChangeValeurMultiple(tabValeurAMettreAJour);
        }
    }

    _onMiseAJourChampNombre = (nomObjet, nomPropriete, valeur, callBack) => {
        if (this.props.onAffichageSansPanel) {
            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur, 'fr');

            let tabValeurAMettreAJour = new Array();
            for (var i = 0; i < 1; i++)
                tabValeurAMettreAJour[i] = new Array();
            tabValeurAMettreAJour[0][0] = nomPropriete;
            tabValeurAMettreAJour[0][1] = (valeur !== "" ? valeur : null);

            this.props.onChangeValeurMultiple(tabValeurAMettreAJour);
        }
        else {
            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur, 'fr', callBack);
        }
    }

    _onMiseAJourChampDemandeBeneficePinel = (isChecked) => {
        let reservationTrav = { ...this.state.reservation };
        reservationTrav.demandeBeneficePinel = isChecked;

        if (!isChecked) {
            reservationTrav.fraisCommissionMontant = null;
            reservationTrav.fraisCommissionPourcentage = null;
        }

        if (this.props.onAffichageSansPanel) {
            let tabValeurAMettreAJour = new Array();

            if (!isChecked) {
                for (var i = 0; i < 3; i++)
                    tabValeurAMettreAJour[i] = new Array();

                tabValeurAMettreAJour[0][0] = "fraisCommissionMontant";
                tabValeurAMettreAJour[0][1] = "";
                tabValeurAMettreAJour[1][0] = "fraisCommissionPourcentage";
                tabValeurAMettreAJour[1][1] = "";
                tabValeurAMettreAJour[2][0] = "demandeBeneficePinel";
                tabValeurAMettreAJour[2][1] = isChecked;

                this.props.onChangeValeurMultiple(tabValeurAMettreAJour);
            }
            else {
                for (var i = 0; i < 1; i++)
                    tabValeurAMettreAJour[i] = new Array();

                tabValeurAMettreAJour[0][0] = "demandeBeneficePinel";
                tabValeurAMettreAJour[0][1] = isChecked;

                this.props.onChangeValeurMultiple(tabValeurAMettreAJour);
            }

            this.setState({ onActiveLesChampsDuFormulaire: isChecked, reservation: reservationTrav });
        }
        else {
            this.setState({ onActiveLesChampsDuFormulaire: isChecked, reservation: reservationTrav }, this._onVerificationFormulaire);
        }
    }

    componentDidMount() { }

    componentDidUpdate() { }

    render() {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return (
                <Panel
                    closeButtonAriaLabel="Fermer"
                    headerText='Clauses spécifiques au contrat'
                    isOpen={this.props.onAffichePanelCommentaire}
                    onDismiss={() => this._onAnnulation()}
                    onOpen={() => this._onOpen()}
                    onRenderFooterContent={this._onRenderFooterContent}
                    type={PanelType.large}
                >
                    <div className={this.props.classname}>
                        <div className={this.props.classnameinner}>
                            <div className="ms-Grid" dir="ltr">
                                <MessageBars
                                    errorMessage={this.state.errorMessage}
                                    warningMessage={this.state.warningMessage}
                                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                                />

                                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                                {content}
                            </div>
                        </div>
                    </div>
                </Panel>
            );
        }
    }
}